import React from "react";
import { StaticQuery, graphql } from "gatsby";
import Masonry from "react-masonry-css";
import MasonryImage from "../components/MasonryImage";
import "../css/App.css";

import Layout from "../components/Layout";
export default function Look() {
  const breakpointColumnsObj = {
    default: 4,
    700: 3,
    500: 2,
  };
  return (
    <StaticQuery
      query={graphql`
        query GalleryImageQuery {
          allCloudinaryMedia(filter: { tags: { eq: "gallery" } }) {
            edges {
              node {
                created_at(formatString: "YYYY-MM-DD")
                public_id
                secure_url
                id
              }
            }
          }
        }
      `}
      render={(data) => (
        <Layout>
          <section className="look">
            <div className="feed look-feed">
              <Masonry
                breakpointCols={breakpointColumnsObj}
                className="my-masonry-grid"
                columnClassName="my-masonry-grid_column"
              >
                {data.allCloudinaryMedia.edges.map((edge) => {
                  return <MasonryImage edge={edge} key={edge.node.id} />;
                })}
              </Masonry>
            </div>
          </section>
        </Layout>
      )}
    />
  );
}
